<template>
  <v-container>
    <div class="d-flex flex-wrap gap-4 mb-8">
      <BaseButton
        v-for="(button, key) in buttons"
        styleType="chip"
        :text="button.text"
        :key="key"
        @click="selectBox = button.value"
        :disabled="selectBox === button.value"
      />
    </div>
    <KeepAlive>
      <BasicData
        v-if="selectBox === 'BasicData'"
        :userData="personalAreaUserEdit ? userData : commonUserData"
        editing
        ref="BasicData"
      />
      <Salary v-else-if="selectBox === 'Salary'" editing ref="Salary"/>
      <AllDate v-else-if="selectBox === 'AllDate'" :employee="commonUserData.employee" />
      <SafetyCard
        v-else-if="selectBox === 'SafetyCard'"
        :userId="userId"
        :safety_card="safety_card"
        editing
        ref="SafetyCard"
        :key="key"
      />
      <Passport
        v-else-if="selectBox === 'Passport'"
        :employeeId="employeeId"
        editing
        :passport_data="passport_data"
        ref="Passport"
      />
      <IdNumber
        v-else-if="selectBox === 'IdNumber'"
        :employeeId="employeeId"
        editing
        :id_data="id_data"
        ref="IdNumber"
      />
      <TaxCard
        v-else-if="selectBox === 'TaxCard'"
        :userId="userId"
        editing
        :tax_card="tax_card"
        ref="TaxCard"
      />
      <ClothesSizes
        v-else-if="selectBox === 'ClothesSizes'"
        :employeeId="employeeId"
        editing
        :clothesSizes="clothesSizes"
        ref="ClothesSizes"
      />
      <ExternalId
        v-else-if="selectBox === 'ExternalId'"
        :external-id="externalId"
        editing
        ref="ExternalId"
      />
      <Skills
        v-else-if="selectBox === 'Skills'"
        editing
        :skills="skills"
        :employeeId="employeeId"
        ref="Skills"
      />
      <TaxNumber
        v-else-if="selectBox === 'TaxNumber'"
        :employeeId="employeeId"
        editing
        :tax_data="tax_data"
        ref="TaxNumber"
      />
      <Valttikortti
        v-else-if="selectBox === 'Valttikortti'"
        :userId="userId"
        editing
        :valttikortti="valttikortti"
        ref="Valttikortti"
      />
      <Note
        v-else-if="selectBox === 'Note'"
        :notesData="notes"
        :employeeId="employeeId"
        editing
        ref="Note"
      />
      <Contract
        v-else-if="selectBox === 'Contract'"
        :userId="userId"
        editing
        :contract="contract"
        ref="Contract"
      />
      <ContactAddress
        v-else-if="selectBox === 'Address'"
        :userId="userId"
        :employeeId="employeeId"
        editing
        :address="address"
        :additional_address="additional_address"
        ref="ContactAddress"
      />
      <StatusAndRole :roles="userData.roles" v-if="admin" />
    </KeepAlive>
    <div class="fixedBtn">
      <BaseTooltip  :tooltip="localStorage.translations.pages.common['buttons']['sohranit']">
        <BaseButton
          :disabled="!navigationGuardianActive"
          @click="onSave"
          round
          icon_only
          size="60"
          default_icon="button-save"
        />
      </BaseTooltip>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import BasicData from 'components/personalArea/BasicData'
import AllDate from 'components/personalArea/AllDate'
import Note from 'components/personalArea/Note'
import StatusAndRole from 'components/personalArea/StatusAndRole'
import SafetyCard from 'components/personalArea/SafetyCard'
import IdNumber from 'components/personalArea/IdNumber'
import TaxNumber from 'components/personalArea/TaxNumber'
import Passport from 'components/personalArea/Passport'
import Valttikortti from 'components/personalArea/Valttikortti'
import ClothesSizes from 'components/personalArea/ClothesSizes'
import TaxCard from 'components/personalArea/TaxCard'
import Contract from 'components/personalArea/Contract'
import Skills from 'components/personalArea/Skills'
import ContactAddress from 'components/personalArea/ContactAddress'
import Salary from 'components/personalArea/Salary'
import ExternalId from 'components/personalArea/ExternalId'

export default {
  name: 'personalAreaAdministration',
  components: {
    BasicData,
    SafetyCard,
    AllDate,
    Note,
    StatusAndRole,
    IdNumber,
    TaxNumber,
    Passport,
    Valttikortti,
    ClothesSizes,
    TaxCard,
    Contract,
    Skills,
    ContactAddress,
    Salary,
    ExternalId,
  },
  data: () => ({
    selectBox: 'BasicData',
    editing: false,
    safety_card: null,
    id_data: null,
    tax_data: null,
    passport_data: null,
    valttikortti: null,
    tax_card: null,
    contract: null,
    skills: [],
    admin: false,
    address: {
      street: null,
      city: null,
      zip: null,
    },
    additional_address: null,
    notes: null,
    employeeId: null,
    userId: null,
    clothesSizes: {},
    key: 0,
    externalId: '',
  }),
  created() {
    this.onDownloadPageData()
    if (this.$route.query.select) {
      this.selectBox = this.$route.query.select
    }
  },
  watch: {
    userData() {
      if (this.personalAreaUserEdit) {
        if (this.userData && this.userData.employee) {
          this.id_data = JSON.parse(this.userData.employee.id_data)
          this.tax_data = JSON.parse(this.userData.employee.tax_data)
          this.passport_data = JSON.parse(this.userData.employee.passport_data)
          this.address = {
            street: this.userData.employee.street,
            city: this.userData.employee.city,
            zip: this.userData.employee.zip,
          }

          this.notes = JSON.parse(this.userData.employee.notes)
          this.clothesSizes = {
            size_shoes: this.userData.employee.size_shoes,
            size_jacket: this.userData.employee.size_jacket,
            size_pants: this.userData.employee.size_pants,
            size_gloves: this.userData.employee.size_gloves,
          }
          this.externalId = this.userData.employee.external_id || ''
          this.skills = this.userData.employee.work_types
        }
      }
    },
    userEmployeeDocGrid() {
      if (this.personalAreaUserEdit) {
        if (this.userEmployeeDocGrid !== null) {
          this.safety_card = this.userEmployeeDocGrid.find((i) => i.type === 'safety_card')
          this.valttikortti = this.userEmployeeDocGrid.find((i) => i.type === 'valttikortti')
          this.tax_card = this.userEmployeeDocGrid.find((i) => i.type === 'tax_card')
          this.contract = this.userEmployeeDocGrid.find((i) => i.type === 'contract')
          this.additional_address = this.userEmployeeDocGrid.find(
            (i) => i.type === 'additional_address',
          )
        }
      }
    },
    commonUserData() {
      if (this.personalAreaEmployeeEdit) {
        if (this.commonUserData && this.commonUserData.employee) {
          this.id_data = JSON.parse(this.commonUserData.employee.id_data)
          this.tax_data = JSON.parse(this.commonUserData.employee.tax_data)
          this.passport_data = JSON.parse(this.commonUserData.employee.passport_data)
          this.address = {
            street: this.commonUserData.employee.street,
            city: this.commonUserData.employee.city,
            zip: this.commonUserData.employee.zip,
          }
          this.notes = JSON.parse(this.commonUserData.employee.notes)
          this.clothesSizes = {
            size_shoes: this.commonUserData.employee.size_shoes,
            size_jacket: this.commonUserData.employee.size_jacket,
            size_pants: this.commonUserData.employee.size_pants,
            size_gloves: this.commonUserData.employee.size_gloves,
          }
          this.employeeId = this.commonUserData.employee.id
          this.userId = this.commonUserData.id
          this.externalId = this.commonUserData.employee.external_id || ''
          this.skills = this.commonUserData.employee.work_types
        }
      }
    },
    employeeDocGrid() {
      if (this.personalAreaEmployeeEdit) {
        if (this.employeeDocGrid !== null) {
          this.safety_card = this.employeeDocGrid.find((i) => i.type === 'safety_card')
          this.valttikortti = this.employeeDocGrid.find((i) => i.type === 'valttikortti')
          this.tax_card = this.employeeDocGrid.find((i) => i.type === 'tax_card')
          this.contract = this.employeeDocGrid.find((i) => i.type === 'contract')
          this.additional_address = this.employeeDocGrid.find(
            (i) => i.type === 'additional_address',
          )
        }
      }
    },
  },
  computed: {
    ...mapGetters('user', ['userData', 'userEmployeeDocGrid']),
    ...mapGetters('employeeDoc', ['employeeDocGrid']),
    ...mapGetters('commonUser', ['commonUserData']),
    ...mapGetters('navigationGuardian', ['navigationGuardianActive']),
    personalAreaUserEdit() {
      return this.$route.name === 'PersonalAreaEdit'
    },
    personalAreaEmployeeEdit() {
      return this.$route.name === 'PersonalAreaEmployeeEdit'
    },
    outputUserIsEmployee() {
      return this.personalAreaUserEdit ? this.userData && Boolean(this.userData.employee) : true
    },
    buttons() {
      const basicButtons = [
        {
          text: this.localStorage.translations.pages['setting-setting_company']['all'][
            'basic_data'
          ],
          value: 'BasicData',
        },
      ]
      const employeeButtons = [
        {
          text: this.localStorage.translations.pages.finance.pages.salary,
          value: 'Salary',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].sections[
            'karta-bezopasnosti-truda'
          ],
          value: 'SafetyCard',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].labels['pasport'],
          value: 'Passport',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].labels['id-nomer'],
          value: 'IdNumber',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].sections[
            'nalogovaya-karta'
          ],
          value: 'TaxCard',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].sections[
            'spetsodezhda'
          ],
          value: 'ClothesSizes',
        },
        {
          text: this.externalIdTitle,
          value: 'ExternalId',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].sections['navyki'],
          value: 'Skills',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].labels[
            'nalogovyy-nomer'
          ],
          value: 'TaxNumber',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].sections[
            'valttikortti'
          ],
          value: 'Valttikortti',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].labels['primechanie'],
          value: 'Note',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].sections['kontrakt'],
          value: 'Contract',
        },
        {
          text: this.localStorage.translations.pages['setting-personal_area'].sections[
            'adres-prozhivaniya-v-finlyandii'
          ],
          value: 'Address',
        },
      ]
      return this.outputUserIsEmployee ? [...basicButtons, ...employeeButtons] : basicButtons
    },
    externalIdTitle() {
      return (
        this.localStorage?.translations?.pages?.common?.text?.worker_id ||
        'Worker ID'
      )
    },
  },
  methods: {
    ...mapActions('user', [
      'getUser',
      'onUserEmployeeDocGrid',
      'onUserUpdateEmployeeData',
      'onUserCreateEmployeeDoc',
      'onUserUpdateEmployeeDoc',
    ]),
    ...mapActions('commonUser', ['onCommonUserData']),
    ...mapMutations('commonUser', ['setCommonUserData']),
    ...mapActions('employeeDoc', [
      'onEmployeeDocGrid',
      'onCreateEmployeeDoc',
      'onUpdateEmployeeDoc',
    ]),
    ...mapMutations('employeeDoc', ['setEmployeeDocGrid']),
    ...mapMutations(['setLoadingAnimationFullPage']),
    ...mapActions('employee', ['onEmployeeUpdate']),
    async onSave() {
      const completeMessage = () =>
        this.$store.dispatch(
          'popup/onMessage',
          {
            message:
              this.localStorage.translations.pages.common.notifications[
                'izmeneniya-uspeshno-sohraneny'
              ],
            IsError: false,
          },
          { root: true },
        )
      const errorMessage = () => {
        this.$store.dispatch(
          'popup/onMessage',
          {
            message: this.localStorage.translations.pages.common.notifications['oshibka'],
            IsError: true,
          },
          { root: true },
        )
      }
      let docRequests = {}
      const checkDoc = (docData) => {
        if (docData !== true) {
          const routeName = this.$route.name
          let result = docData.id
            ? routeName === 'PersonalAreaEmployeeEdit'
              ? 'onUpdateEmployeeDoc'
              : 'onUserUpdateEmployeeDoc'
            : docData.user_id
            ? 'onCreateEmployeeDoc'
            : 'onUserCreateEmployeeDoc'
          docRequests = this[result](docData)
        }
      }
      let ref = 'ContactAddress'
      if (this.selectBox !== 'Address') ref = this.selectBox
      console.log(this.$refs[ref])
      if (
        this.$refs[ref] &&
        this.$refs[ref].$refs &&
        (!this.$refs[ref].$refs.form || this.$refs[ref].$refs.form.validate())
      ) {
        const refSave = await Promise.all([this.$refs[ref].saveChange()])
        let userData = {}
        if (
          ref == 'ClothesSizes' ||
          ref == 'IdNumber' ||
          ref == 'TaxNumber' ||
          ref == 'Passport' ||
          ref == 'Skills' ||
          ref == 'ExternalId'
        )
          userData = { ...refSave['0'] }
        if (ref == 'ContactAddress') {
          userData = { ...refSave['0'].address }
          checkDoc(refSave['0'].additionalAddress)
        }
        if (ref == 'SafetyCard' || ref == 'Valttikortti' || ref == 'TaxCard' || ref == 'Contract')
          checkDoc(refSave['0'])
        let data = {}
        if (this.$route.name === 'PersonalAreaEmployeeEdit') {
          if (
            Object.keys(userData).length &&
            this[this.personalAreaUserEdit ? 'userData' : 'commonUserData'].type !== 'superadmin' &&
            this[this.personalAreaUserEdit ? 'userData' : 'commonUserData'].employee
          ) {
            data.id = this.commonUserData.employee.id
          }
        }
        data = Object.assign(data, userData)
        Promise.all([
          this.$refs.BasicData ? this.$refs.BasicData.saveChange() : null,
          Object.keys(data).length
            ? this[
                this.$route.name === 'PersonalAreaEmployeeEdit'
                  ? 'onEmployeeUpdate'
                  : 'onUserUpdateEmployeeData'
              ](data)
            : true,
          docRequests,
        ])
          .then(async (resp) => {
            await this.onDownloadPageData()
            completeMessage()
          })
          .catch(() => {
            errorMessage()
          })
      }
    },

    async onDownloadPageData() {
      this.setLoadingAnimationFullPage(true)
      if (this.personalAreaUserEdit) {
        await Promise.all([this.getUser(), this.onUserEmployeeDocGrid()])
      } else if (this.personalAreaEmployeeEdit) {
        await this.downloadEployeeData()
      }
      this.setLoadingAnimationFullPage(false)
    },
    save(date) {
      this.$refs.menu.save(date)
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    async downloadEployeeData() {
      this.onCommonUserData(this.$route.params.userId)
      this.onEmployeeDocGrid(this.$route.params.userId)
    },
  },
  destroyed() {
    this.setCommonUserData()
    this.setEmployeeDocGrid()
  },
}
</script>
